import React, { forwardRef } from 'react';
interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  options: {
    value: string;
    label: string;
  }[];
  error?: string;
}
export const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  label,
  options,
  error,
  className = '',
  ...props
}, ref) => {
  return <div className={`flex flex-col w-full ${className}`} data-id="element-178">
        <label className="text-xs font-medium text-luxury-gray uppercase tracking-wider mb-2 ml-1" data-id="element-179">
          {label}{' '}
          {props.required && <span className="text-luxury-gold" data-id="element-180">*</span>}
        </label>
        <div className="relative" data-id="element-181">
          <select ref={ref} className={`w-full bg-luxury-darkgray/50 border ${error ? 'border-red-500/50' : 'border-white/10'} rounded-xl px-4 py-3.5 text-luxury-white appearance-none focus:outline-none focus:border-luxury-gold focus:ring-1 focus:ring-luxury-gold transition-colors allow-select`} {...props} data-id="element-182">
            <option value="" disabled data-id="element-183">
              Select an option
            </option>
            {options.map(opt => <option key={opt.value} value={opt.value} className="bg-luxury-darkgray text-luxury-white" data-id="element-184">
                {opt.label}
              </option>)}
          </select>
          <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none" data-id="element-185">
            <svg className="w-4 h-4 text-luxury-gray" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-186">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-187" />
            </svg>
          </div>
        </div>
        {error && <span className="text-xs text-red-400 mt-1.5 ml-1" data-id="element-188">{error}</span>}
      </div>;
});
Select.displayName = 'Select';